"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.device = void 0;
const styled_components_1 = require("styled-components");
const deviceMedia = {
    mobile: '(min-width: 320px)',
    mobileLandscape: '(min-width: 568px)',
    tablet: '(min-width: 641px)',
    desktop: '(min-width: 940px)',
};
const constructCssMedia = (media, ...args) => {
    return (0, styled_components_1.css) `
    @media screen and ${media} {
      ${(0, styled_components_1.css)(...args)}
    }
  `;
};
exports.device = {
    mobile: (...args) => constructCssMedia(deviceMedia.mobile, ...args),
    mobileLandscape: (...args) => constructCssMedia(deviceMedia.mobileLandscape, ...args),
    tablet: (...args) => constructCssMedia(deviceMedia.tablet, ...args),
    desktop: (...args) => constructCssMedia(deviceMedia.desktop, ...args),
};
